import { FormikHelpers } from 'formik'

import { useShowGenericServerError } from '@/hooks/useShowGenericServerError'
import { handleConstraintViolationListError } from '@/lib/helpers/helperFunctions'
import errorTypeService from '@/lib/services/errorTypeService'

export function useHandleApiError() {
  const showGenericServerError = useShowGenericServerError()

  function handleApiError({
    error,
    formikHelpers,
  }: {
    error: unknown

    // This is a rare case where it's ok to use `any` but in general we should
    // avoid it
    formikHelpers: FormikHelpers<any> // eslint-disable-line @typescript-eslint/no-explicit-any
  }) {
    if (errorTypeService.isConstraintViolationListError(error)) {
      handleConstraintViolationListError({ error, formikHelpers })
      return
    }

    showGenericServerError()
  }

  return handleApiError
}
